export const integrationInvocationsMutationKeys = {
  createWebhookInvocation: (teamId: string) =>
    ['integration-invocations', { teamId }] as const
}
